import { render, staticRenderFns } from "./serviceChannel.vue?vue&type=template&id=60bb6162&scoped=true"
import script from "./serviceChannel.vue?vue&type=script&lang=js"
export * from "./serviceChannel.vue?vue&type=script&lang=js"
import style0 from "./serviceChannel.vue?vue&type=style&index=0&id=60bb6162&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb6162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bb6162')) {
      api.createRecord('60bb6162', component.options)
    } else {
      api.reload('60bb6162', component.options)
    }
    module.hot.accept("./serviceChannel.vue?vue&type=template&id=60bb6162&scoped=true", function () {
      api.rerender('60bb6162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelManage/serviceProviderChannel/serviceChannel.vue"
export default component.exports